import React from "react";
import { Link } from "react-router-dom";
import { FaGithub } from "react-icons/fa";
import { FaExternalLinkAlt } from "react-icons/fa";

const ProjectDetails = ({
  projectDescription,
  projectGithubLink,
  projectHeading,
  projectId,
  projectImage,
  projectLiveLink,
  projectReadmeLink,
  projectTechStack,
}) => {
  return (
    <div
      style={{ backgroundImage: `url(${projectImage})`, borderRadius: "8px" }}
      className={
        projectId % 2
          ? "h-[525px] xl:h-[550px] w-[90%] bg-contain bg-no-repeat  bg-center relative project-card-box-shadow rounded-lg mx-auto xl:ml-[0%]"
          : " h-[525px] xl:h-[550px] w-[90%] bg-contain bg-no-repeat  bg-center relative project-card-box-shadow rounded-lg mx-auto xl:ml-[10%]"
      }
    >
      <h2
        className={
          projectId % 2
            ? "text-white absolute -right-8 -top-10 lg:-right-10 lg:-top-11 text-8xl lg:text-9xl font-semibold xl:hidden z-10 project-number-heading project-number-heading-right"
            : "text-white absolute -left-8 lg:-left-10 -top-10 lg:-top-11 text-8xl lg:text-9xl font-semibold xl:hidden z-10 project-number-heading project-number-heading-left"
        }
      >
        {projectId < 10 ? `0${projectId}` : projectId}
      </h2>

      <div
        className={
          projectId % 2
            ? "flex flex-col gap-3 lg:gap-4 text-white p-6 lg:p-8 absolute left-[10%] bottom-[20%] project-zoom-in-text "
            : "flex flex-col gap-3 lg:gap-4 text-white p-6 lg:p-8 absolute left-[10%] xl:right-[10%] bottom-[20%] project-zoom-in-text "
        }
      >
        {/* project-tech-stack */}
        <div className="max-w-[100%] xl:max-w-[60%] w-fit flex gap-2 flex-wrap project-tech-stack">
          {projectTechStack.map((eachProjectIcon, index) => {
            return (
              <img
                className="w-[35px] lg:w-[40px] object-contain project-card-image"
                src={require(`../assets/tech-stack/${eachProjectIcon}`)}
                alt={eachProjectIcon}
                key={index}
              />
            );
          })}
        </div>

        <h2 className="text-4xl lg:text-5xl font-bold leading-10 project-card-heading">
          {projectHeading}
        </h2>

        <h2 className="text-base lg:text-lg w-[100%] lg:w-[70%] italic project-card-sub-heading">
          {projectDescription}
        </h2>

        {/* link container */}
        <div className="flex gap-4 items-center project-card-btn-container">
          <Link
            target="_blank"
            to={projectReadmeLink}
            className="bg-[#e84949] text-white text-lg font-normal rounded-md py-2 px-4 lg:px-6 button-shadow project-read-more-btn"
          >
            Read More
          </Link>
          <Link
            title="Github Link"
            target="_blank"
            to={projectGithubLink}
            className="text-2xl font-normal project-card-icons"
          >
            <FaGithub />
          </Link>
          {projectLiveLink ? (
            <Link
              title="Live Link"
              target="_blank"
              to={projectLiveLink}
              className="text-2xl font-normal project-card-icons"
            >
              <FaExternalLinkAlt />
            </Link>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default ProjectDetails;
